import axios from "axios";
import apiUrlOne from "../Config";

export const adminUserLogin = async (email, password) => {
    try {
        const response = await axios.post(
            `${apiUrlOne}/adminusers/adminuser-login`,
            { email, password },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        return response.data; // { message, token }
    } catch (error) {
        if (error.response && error.response.data) {
            throw new Error(error.response.data.message || "Login failed");
        } else {
            throw new Error("Server not reachable. Try again later.");
        }
    }
};
